var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Text, Heading, Button, Icon } from 'shared/components';
import { ChevronRightSmall, Document } from 'shared/assets/icons';
import { formatFullDateTime } from 'shared/utils/dates';
import { appointmentKindLabels } from 'constants/appointmentKind';
export var UpcomingAppointmentInfo = function (_a) {
    var date = _a.date, appointmentKind = _a.appointmentKind, memberId = _a.memberId, index = _a.index, openable = _a.openable;
    return (_jsxs(Flex, __assign({ align: "center", h: "100%", justify: "space-between", w: "100%", "data-testid": "upcomingAppointmentInfo" }, { children: [_jsxs(Flex, __assign({ direction: "column" }, { children: [_jsx(Heading, __assign({ size: "h4", mb: 1 }, { children: formatFullDateTime(date, true) })), _jsx(Text, __assign({ color: "gray.500", "data-testid": "".concat(memberId, "-").concat(appointmentKind) }, { children: appointmentKindLabels[appointmentKind]
                            ? appointmentKindLabels[appointmentKind]
                            : appointmentKind }))] })), openable && (_jsx(Button, __assign({ "data-testid": "open_note-button-".concat(index), variant: 'links', padding: 0, leftIcon: _jsx(Icon, { as: Document, boxSize: 4 }), rightIcon: _jsx(Icon, { as: ChevronRightSmall, boxSize: 4 }) }, { children: "Open note" })))] })));
};
